<template>
  <div class="record-item">
    <ul>
        <li>订单号：<a>{{ SafeItem.order_no }}</a></li>
        <li>领取时间：<a>{{ SafeItem.addtime }}</a></li>
        <li>领取金额：<a>{{ SafeItem.money }}</a></li>
        <li>账户变更：<a>{{ SafeItem.before_money }} → {{ SafeItem.after_money }}</a></li>
        <li style="border: none;">备注：{{ SafeItem.remark }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name:'FanShuiRecoedItem',
  props:['item'],
  computed:{
    SafeItem(){
        return this.item ||null
    }
  }
}
</script>
<style lang="scss" scoped>
.record-item{
    width: calc(90% - 40px);
    margin: 14px auto 0;
    background: rgb(0, 0, 0,.65);
    border-radius: 10px;
    padding: 10px 20px;
    text-align: left;
    ul {
        width: 100%;
        font-size: 16px;
        li {
            position: relative;
            border-bottom: 1px solid #3e435d;
            line-height: 2;
            a {
                position: absolute;
                right: 0;
            }
        }
    }
}
</style>
